import React from 'react'

import Skeleton from "@material-ui/lab/Skeleton";

const ArticleLoader = ({lang }) => {
    return (
        <div className="article" style={{background:'transparent',}}>
            <Skeleton variant="rect" height={218} />
            <br/>
            <Skeleton variant="h3" width="100%"/>
            <br/>
            <Skeleton variant="h6" width="80%" style={{margin:'0 auto'}}/>
            <br/>
            <div style={{backgroundColor:'#e9e9e9'}}  className="bottom">
            {lang === "ar" ? "قرأ المقال " : "خواندن مقاله"}
            </div>
        </div>
    )
}

export default ArticleLoader
